/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function ExportEntryLinksRequestFromJSON(json) {
    return ExportEntryLinksRequestFromJSONTyped(json, false);
}
export function ExportEntryLinksRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        entryLinkIds: json['entryLinkIds'],
    };
}
export function ExportEntryLinksRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        entryLinkIds: value.entryLinkIds,
    };
}
